var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.16992 7.44043L11.9999 12.5504L20.7699 7.47043",
    stroke: "#434343",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 21.61V12.54",
    stroke: "#434343",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.93062 2.48028L4.59063 5.44028C3.38063 6.11028 2.39062 7.79028 2.39062 9.17028V14.8203C2.39062 16.2003 3.38063 17.8803 4.59063 18.5503L9.93062 21.5203C11.0706 22.1503 12.9406 22.1503 14.0806 21.5203L19.4206 18.5503C20.6306 17.8803 21.6206 16.2003 21.6206 14.8203V9.17028C21.6206 7.79028 20.6306 6.11028 19.4206 5.44028L14.0806 2.47028C12.9306 1.84028 11.0706 1.84028 9.93062 2.48028Z",
    stroke: "#434343",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/Icon.22be18688e77f2b930b5f4f1f18871f2.svg";
export { ForwardRef as ReactComponent };